export default "__VITE_ASSET__nZbTa91O__"